(function () {
  'use strict';

  if (window.__mwDyt) return;
  window.__mwDyt = true;

  function init() {
    var sections = document.querySelectorAll('[data-section-id][data-msg]');
    sections.forEach(function (section) {
      bindSection(section);
    });
  }

  function bindSection(section) {
    var opts = section.querySelectorAll('[data-dyt-opt]');
    var summary = section.querySelector('[data-dyt-summary]');
    var sendBtn = section.querySelector('[data-dyt-send]');
    var msgIntro = section.getAttribute('data-msg') || 'Hello Moroccan Wizards, here is the trip I composed:';
    var waBase = sendBtn ? sendBtn.getAttribute('data-wa') : '';

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-cat');
        var group = section.querySelector('[data-dyt-group][data-cat="' + cat + '"]');
        var mode = group ? group.getAttribute('data-mode') : 'single';
        var isPressed = btn.getAttribute('aria-pressed') === 'true';

        if (mode === 'single') {
          // deselect siblings in same cat
          var siblings = section.querySelectorAll('[data-dyt-opt][data-cat="' + cat + '"]');
          siblings.forEach(function (s) {
            s.setAttribute('aria-pressed', 'false');
            s.classList.remove('is-picked');
          });
          // toggle: if it was already selected, leave deselected; otherwise select
          if (!isPressed) {
            btn.setAttribute('aria-pressed', 'true');
            btn.classList.add('is-picked');
          }
        } else {
          // multi: simple toggle
          var next = isPressed ? 'false' : 'true';
          btn.setAttribute('aria-pressed', next);
          btn.classList.toggle('is-picked', next === 'true');
        }

        updateRecap(section, summary, sendBtn, waBase, msgIntro);
      });
    });
  }

  function updateRecap(section, summary, sendBtn, waBase, msgIntro) {
    var picked = { stay: [], car: [], table: [] };

    section.querySelectorAll('[data-dyt-opt][aria-pressed="true"]').forEach(function (btn) {
      var cat = btn.getAttribute('data-cat');
      var label = btn.getAttribute('data-label');
      if (picked[cat] !== undefined && label) {
        picked[cat].push(label);
      }
    });

    var parts = [];
    if (picked.stay.length) parts.push('Stay: ' + picked.stay.join(', '));
    if (picked.car.length) parts.push('Move: ' + picked.car.join(', '));
    if (picked.table.length) parts.push('Tables: ' + picked.table.join(', '));

    var total = picked.stay.length + picked.car.length + picked.table.length;

    if (total === 0) {
      // restore placeholder — read from a fallback if needed
      var emptyLabel = section.querySelector('[data-dyt-summary]');
      // keep existing text (first render sets it via Liquid) or use fallback
      if (summary) summary.textContent = summary.getAttribute('data-empty') || 'Pick a stay to begin.';
      if (sendBtn) sendBtn.setAttribute('hidden', '');
    } else {
      if (summary) {
        // cache the empty label on first non-empty update
        if (!summary.getAttribute('data-empty')) {
          summary.setAttribute('data-empty', summary.textContent);
        }
        summary.textContent = parts.join(' · ');
      }
      if (sendBtn && waBase) {
        var lines = [];
        if (picked.stay.length) lines.push('Stay: ' + picked.stay.join(', '));
        if (picked.car.length) lines.push('Move: ' + picked.car.join(', '));
        if (picked.table.length) lines.push('Tables: ' + picked.table.join(', '));
        var message = msgIntro + '\n' + lines.join('\n');
        sendBtn.href = waBase + '?text=' + encodeURIComponent(message);
        sendBtn.removeAttribute('hidden');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
